import { handleExpiracion } from "../services/userServices";
import { AES, enc, pad } from 'crypto-js';
import { trackModuleAccess } from "./analytics";

export const isBrowser = () => typeof window !== "undefined";

export const getPathname = () => {
  const pathname =
    isBrowser() && window !== "undefined" ? window.location.pathname : "";
  return pathname;
};
export const mapAttributes = (attributes) => {
  const attr = {};
  attributes.forEach((x) => {
    attr[getNameValue(x["Name"])] = x["Value"];
  });

  return attr;
};

export const mapAttributesObj = (obj) => {
  const attr = {};
  Object.keys(obj).forEach((x) => {
    attr[getNameValue(x)] = obj[x];
  });

  return attr;
};

export const getNameValue = (name) => {
  const nameFormat = name.split(":");
  return nameFormat[nameFormat.length - 1];
};

export const getDate = () => {
  var today = new Date();
  var now = today.toLocaleString();
  return now;
};

export const getBrowserInfo = () => {
  var ua = navigator.userAgent,
    tem,
    M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return "IE " + (tem[1] || "");
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return M.join(" ");
};

export const getStorage = (key, isObject) => {
  try {
    const storage = localStorage.getItem(key);
    if (isObject) {
      if (/^[\d]/.test(storage)) {
        return null;
      }
      const obj = JSON.parse(storage);
      return obj ? obj : null;
    }
    return storage;
  } catch (error) {
    localStorage.removeItem(key);
    return null;
  }
};

export const getFilteredValue = (dataFilter, key) => {
  const findFilter = dataFilter.find((e) => e.key === key);
  if (findFilter) {
    return findFilter.value.toString();
  }
  return null;
};

export const getFormatDate = (timestamp) => {
  let date = new Date(timestamp);
  date.setDate(date.getDate() + 1);
  return date.toLocaleDateString().split(",")[0];
};

export const updateDate = (allData) => {
  return allData.map((element) => {
    if (element.fecha) {
      element["fecha"] = getFormatDate(element.fecha);
    }
    return element;
  });
};
export const getTimeStamp = (date) => {
  if (date.split("-").length > 1) {
    let newDate = new Date(date);
    return newDate.getTime();
  }
  let date1 = new Date(parseInt(date));
  return date1.getTime();
};
export const getColorNps = (data) => {
  let color;
  if (data === 0) {
    color = "#FFFFFF";
  }
  if (data) {
    if (data < 60) {
      color = "#DB000C";
    }
    if (data >= 60 && data < 80) {
      color = "#ffbc00";
    }
    if (data >= 80) {
      color = "#0A8246";
    }
  }
  return color;
};

export const getColorIndicator = (data) => {
  let color;
  if (data === 0) {
    color = "#FFFFFF";
  }
  if (data) {
    if (data < 90) {
      color = "#DB000C";
    }
    if (data >= 90) {
      color = "#0A8246";
    }
  }
  return color;
};

export const validateRecurso = (recursos, recurso) => {
  if (recursos) {
    const findRecurso = recursos.find((e) => e == recurso);
    if (findRecurso || recurso.includes("/perfil")) {
      return true;
    }
    return false;
  }
};

export const validateDirectivas = (directivas, directiva) => {
  if (directivas) {
    const findRDirectiva = directivas.find((e) => e == directiva);
    if (findRDirectiva) {
      return true;
    }
    return false;
  }
};

export const getStores = (dependencies, navstore) => {
  let stores = [];
  if (dependencies && dependencies.length && navstore) {
    navstore.forEach((tag) => {
      const findStore = dependencies.find((e) => e.almacennav === tag);
      if (findStore) {
        stores.push(
          `${findStore.almacennav}-${findStore.razonsocial}-${findStore.direccion}`
        );
      }
    });
    return stores;
  }
  return "";
};

export const getCodes = (dependencies, navstore) => {
  let codeStore = [];
  if (dependencies && dependencies.length && navstore) {
    navstore.forEach((nav) => {
      const findStore = dependencies.find((e) => `${e.almacennav}-${e.razonsocial}-${e.direccion}` === nav);
      if (findStore) {
        codeStore.push(findStore.almacennav);
      }
    });
    return codeStore.join(",");
  }
  return "";
};

export const getExpiration = (token) => {
  const tokenSections = (token || "").split(".");
  if (tokenSections.length < 2) {
    return false
  }
  const payloadJSON = JSON.parse(atob(tokenSections[1]))
  return handleExpiracion(payloadJSON.exp)
}

/**
 * Función para obtener nit de dependencias
 * 
 * by: snevado
 * date: 2023/05/17
 */
export const getNitStores = (dependencies, navstore) => {
  let stores = [];
  if (dependencies && dependencies.length && navstore) {
    navstore.forEach((tag) => {
      const findStore = dependencies.find((e) => e.almacennav === tag);
      if (findStore) {
        stores.push(
          `${findStore.nit}`
        );
      }
    });
    return stores;
  }
  return stores;
};

/**
 * Función para encriptar un texto
 * 
 * by: snevado
 * date: 2023/07/11
 */
export const encryptData = (data) => {
  try {
    const keyEncrypt = process.env.KEY_JS;
    const ivEncrypt = process.env.IV_JS;

    const key = enc.Hex.parse(keyEncrypt.toString());
    const iv = enc.Hex.parse(ivEncrypt.toString());

    const encrypted = AES.encrypt(data, key, {
      iv,
      padding: pad.ZeroPadding,
    });

    return encrypted.toString();
  } catch (err) {
    console.log('UNABLE TO DECIPHER', err);
    return "";
  }
};

export const modulesAddToken = [
  'modulo.auditoria',
  'modulo.alistamientos',
  'modulo.registropagos',
  'modulo.b2b',
  'modulo.b2b.pruebas',
  'modulo.b2b.dllo',
  'modulo.calidadproveedores',
  'modulo.registropagos.dllo',
  'modulo.cotizadorrepuestos',
  'modulo.certificadosproveedores',
  'modulo.distribuidores',
  'modulo.calidadproveedores.dllo',
  'modulo.leadmanager',
  'modulo.leadmanagerpruebas',
  'modulo.lineaensamble',
  'modulo.seguroempleados.pruebas',
  'modulo.csa218',
  'modulo.csa218.admin',
  'modulo.calidadproveedores.pruebas',
  'modulo.intranet',
  'modulo.edukando.dllo',
  'modulo.lineaensamble.dllo',
  'modulo.pagosterceros.dllo',
  'modulo.biblioteca',
  'modulo.agendamientocitas',
  'modulo.tickelia',
  'modulo.calidadproveedores2',
  'modulo.negociacionprecios',
  'modulo.tableromarcadora.dllo',
  'modulo.cotizadormostrador',
  'modulo.pagosterceros.pruebas',
  'modulo.edukandos',
  'modulo.edukando',
  'modulo.biblioteca.pruebas',
  'modulo.pagosterceros.aws',
  'modulo.calidadproveedores.aws',
  'modulo.seguroempleados.aws',
  'modulo.activosfijos',
  'modulo.tickelia.dllo',
  'modulo.mejoramientos.dllo',
  'modulo.tableromarcadora',
  'modulo.cuentacompensacion.dllo',
  'modulo.b2b.aws',
  'modulo.cuentacompensacion',
  'modulo.seguroempleados',
  'modulo.codigounico.aws',
  'modulo.mejoramientos.aws',
  'modulo.materiaprima.dllo',
  'modulo.codigounico',
  'modulo.mejoramientos',
  'modulo.agendamientocitas.dllo',
  'modulo.extranet.dllo',
  'modulo.extranet',
  'modulo.distribuidores.dllo',
  'modulo.pqr.dllo',
  'modulo.pqr',
  'modulo.pagosterceros',
  'modulo.lineaensamble.test',
  'modulo.tracker.test',
  'modulo.materiaprima',
  'modulo.yamaherodecorazon',
  'modulo.yamaherodecorazon.dllo',
  'modulo.reportesinternos',
  'modulo.reportesinternos.dllo',
  'modulo.desarrolloseguro.dllo',
  'modulo.desarrolloseguro.aws',
  'modulo.desarrolloseguro',
  "modulo.renting.aws",
  "modulo.renting",
  "modulo.saiav8auth.dllo",
  "modulo.saiav8auth",
  "modulo.agentemecanico.dllo",
  "modulo.agentemecanico",
  "modulo.administradorbaseconocimiento.dllo",
  "modulo.administradorbaseconocimiento",
  "modulo.cotizaimportacionrespuestosv2.dllo",
  "modulo.cotizaimportacionrespuestosv2"
];

export const changeUrl = (event, url, id, user) => {
  if (event && typeof event.preventDefault === 'function') {
    event.preventDefault();
  }
  
  trackModuleAccess(id, url);
  
  const encrypted = encryptData(user["token"]);
  const separator = url.includes('?') ? '&' : '?';
  let newUrl = `${url}${separator}token=${encodeURIComponent(encrypted)}`;
  if (id === 'modulo.cotizadormostrador') {
    newUrl += '&counter=1';
  }
  if (id === 'modulo.distribuidores' || id === 'modulo.distribuidores.dllo') {
    newUrl += '&redirect=/status-certification';
  }
  if (event) {
    window.open(newUrl, '_blank');
    return false;
  }
  return newUrl;
};
